<template>
  <div>
    <div v-if="error.length">
      <b-alert variant="danger">{{ error }}</b-alert>
      <b-button @click="fetchQuestion">Lae uuesti</b-button>
    </div>

    <div v-else-if="isBusy">
      <div class="text-center text-danger my-2">
        <b-spinner class="align-middle"></b-spinner>
        <strong>Küsimust laetakse..</strong>
      </div>
    </div>

    <div v-else>
      <b-img
        v-if="question.sponsor_logo"
        :src="question.sponsor_logo"
        center
        class="mb-3 vote-icon"
      ></b-img>
      <h2 class="mb-4">{{ question.question }}</h2>
      <div class="voting-box">
        <span v-html="question.campaign_rules"></span>

        <b-form>
          <b-form-group>
            <b-form-checkbox v-model="formValues.acceptTerms"
              >Nõustun kampaania tingimustega *</b-form-checkbox
            >
          </b-form-group>

          <b-form-group v-if="question.raffle_name">
            <b-form-checkbox v-model="formValues.send_campaign_info"
              >{{ question.raffle_name }} (<b-link v-b-modal.raffle_description
                >reeglid</b-link
              >)</b-form-checkbox
            >

            <b-modal id="raffle_description" title="Reeglid" hide-footer>
              <div v-html="question.raffle_description"></div>
            </b-modal>
          </b-form-group>

          <b-form-group v-for="field in inputFields" :key="field.key">
            <b-form-input
              v-if="
                question.required_contact_fields.includes(field.key) ||
                  question.optional_contact_fields.includes(field.key)
              "
              :id="field.key"
              :type="field.type"
              :placeholder="
                field.label +
                  (question.required_contact_fields.includes(field.key)
                    ? ' *'
                    : '')
              "
              :state="mySelf[field.key + 'Validation']"
              v-model="formValues[field.key]"
            ></b-form-input>
          </b-form-group>
        </b-form>

        <h3 class="mt-4">Vali sobiv vastusevariant</h3>
        <div
          v-for="option in question.options"
          :key="option.id"
          class="option-button row"
          @click="submitVote(option.id)"
        >
          <!-- <img v-if="option.icon" :src="option.icon" />
          {{ option.option }}-->

          <div v-if="option.icon" class="col-4">
            <img :src="option.icon" />
          </div>
          <div :class="{ 'col-8': option.icon, 'col-12': !option.icon }">
            {{ option.option }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "Voting",
  data() {
    return {
      question: null,
      inputFields: [
        {
          key: "name",
          label: "Nimi",
          type: "text"
        },
        {
          key: "email",
          label: "E-mail",
          type: "email"
        },
        {
          key: "phone",
          label: "Telefon",
          type: "tel"
        }
      ],
      formValues: {
        acceptTerms: false,
        send_campaign_info: null,
        name: null,
        email: null,
        phone: null
      },
      error: "",
      isBusy: true,
      mySelf: this
    };
  },
  computed: {
    nameValidation() {
      return this.initValidation("name");
    },
    emailValidation() {
      return this.initValidation("email");
    },
    phoneValidation() {
      return this.initValidation("phone");
    },
  },
  mounted() {
    this.fetchQuestion();
  },
  methods: {
    submitVote(option) {
      if (this.formValues.acceptTerms) {
        if (this.nameValidation !== false && this.emailValidation !== false && this.phoneValidation !== false) {
          axios
            .post(process.env.VUE_APP_BACKEND_HOST + "/api/v1/voting/votes/" + option, this.formValues, { withCredentials: true })
            .then(() => {
              if(window.dataLayer) {
                window.dataLayer.push({
                  'event': 'Voting',
                  'eventCategory': 'Voting',
                  'eventAction': this.question.question,
                  'eventLabel': this.question.options.filter(item => {
                    return item.id === option;
                  })[0].option
                });
              }
              this.$router.push("/voted");
            })
            .catch(err => {
              console.log(err);
            });
        } else {
          alert("Kõik kohustuslikud väljad ei ole nõuetekohaselt täidetud");
        }
      } else {
        alert("Hääletamiseks peab olema tingimustega nõustunud");
      }
    },
    fetchQuestion() {
      this.error = "";
      axios
        .get(
          process.env.VUE_APP_BACKEND_HOST +
            "/api/v1/voting/questions/" +
            this.$route.params.id
        )
        .then(response => {
          this.question = response.data;
          //console.log(this.question);
        })
        .catch(err => {
          console.log(err);
          this.error = "Viga serveriga";
        })
        .finally(() => {
          this.isBusy = false;
        });
    },
    validate(field) {
      if (this.formValues[field]) {
        let emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        let phoneRegex = /^(?=(?:\D*\d){6,})\+?[\(\)\d\s-]*$/;
        switch (field) {
          case "name":
            return this.formValues.name.length > 1;
          case "email":
            return emailRegex.test(this.formValues.email);
          case "phone":
            return phoneRegex.test(this.formValues.phone);
        }
      }

      return false;
    },
    initValidation(field) {
      if (this.formValues[field] || this.question.required_contact_fields.includes(field)) {
        // If field is filled or required, we validate it directly anyway
        return this.validate(field);
      } else if (this.question.optional_contact_fields.includes(field) && this.formValues.send_campaign_info) {
        // If the other optional values are validated true
        let optionalFields = this.question.optional_contact_fields;
        if (optionalFields.length == 1) {
          // When requesting campaign info, the field becomes mandatory
          return false;
        }

        let existsValidatedField = false;
        optionalFields.forEach(item => {
          existsValidatedField = existsValidatedField || this.validate(item);
        });

        if (!existsValidatedField) {
          return false;
        }
      }

      return null;
    }
  }
};
</script>
